module.exports = __webpack_public_path__ + "img/clock.f34127b6.svg";